__webpack_require__.hmrF = () => ("accordion-item." + __webpack_require__.h() + ".hot-update.json");